"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconStopWatch = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconStopWatch = function SvgIconStopWatch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.552 2.308l-.362.57a5.113 5.113 0 011.93 4.002A5.126 5.126 0 016 12 5.126 5.126 0 01.88 6.88c0-2.64 2.009-4.82 4.578-5.092v-.704h-.034a.542.542 0 010-1.084h1.152a.542.542 0 110 1.084h-.034v.704c.617.065 1.202.24 1.734.506l.36-.568a.542.542 0 11.916.582zM1.964 6.88A4.04 4.04 0 006 10.916a4.04 4.04 0 004.036-4.036A4.04 4.04 0 006 2.844 4.04 4.04 0 001.964 6.88zm5.08-2.021a.542.542 0 01.817.712L6.409 7.236a.542.542 0 01-.818-.713L7.044 4.86z",
    fill: "currentColor"
  }));
};

exports.SvgIconStopWatch = SvgIconStopWatch;